function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.68,25.4c-1.21,1.77-2.47,3.52-4.45,3.56s-2.58-1.15-4.8-1.15S9.5,28.92,7.66,29s-3.37-1.91-4.6-3.67c-2.5-3.6-4.41-10.18-1.84-14.61a7.12,7.12,0,0,1,6-3.64c1.88,0,3.65,1.26,4.8,1.26S15.35,6.79,17.61,7a6.79,6.79,0,0,1,5.33,2.87,6.57,6.57,0,0,0-3.15,5.52,6.4,6.4,0,0,0,3.91,5.86A15.47,15.47,0,0,1,21.68,25.4ZM13.36,2.2A6.51,6.51,0,0,1,17.64,0a6.39,6.39,0,0,1-1.51,4.63,5.38,5.38,0,0,1-4.32,2.05A6,6,0,0,1,13.36,2.2Z",
    style: {
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.2c39ba245b56287dc9e980b1153a5d6c.svg";
export { ForwardRef as ReactComponent };